import React, { useMemo, useState } from "react";
import {
  CalendarDays,
  Wrench,
  CarFront,
  PaintBucket,
  Wallet,
  Search,
} from "lucide-react";
import PMS from "./PMS";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import DaterangePicker from "../../common/Daterangepicker";
import { useSelector } from "react-redux";
import Runningrepair from "./Runningrepair";
import Accidents from "./Accidents";
import ComingSoon from "../../common/ComingSoon";
import Tinkeringandpainting from "./Tinkeringandpainting";

const Servicestatus = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const [selectedTab, setSelectedTab] = useState("pms");
  const [cityFilter, setCityFilter] = useState("");
  const [savedAmount, setSavedAmount] = useState(null);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  const maintenanceTabs = [
    {
      id: "pms",
      label: "PMS",
      icon: CalendarDays,
      savedAmount: 0,
    },
    {
      id: "runningRepairs",
      label: "Running Repairs",
      icon: Wrench,
      savedAmount: 0,
    },
    {
      id: "accidents",
      label: "Accidents",
      icon: CarFront,
      savedAmount: 0,
    },
    {
      id: "tinkeringPainting",
      label: "Tinkering & Painting",
      icon: PaintBucket,
      savedAmount: 0,
    },
  ];

  return (
    <div className="my-8">
      {/* <div className="w-full my-2 bg-white border-b border-[#E5E7EB] shadow-sm px-8 py-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 my-6 rounded-lg">
        <div className="flex items-center gap-3">
          <h1 className="text-gray-900 text-2xl font-bold tracking-tight uppercase">
            Service Status
          </h1>
        </div>

        <div className="flex gap-4 justify-end">
          <DaterangePicker
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
            style={-10}
          />

          <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
            <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="flex-shrink-0 w-4 h-4"
              >
                <path
                  d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                  stroke="#99A1AF"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                  stroke="#99A1AF"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <Citiescommondropdown
                value={cityFilter}
                onChange={setCityFilter}
                options={[{ value: null, label: "All Cities" }, ...cityOptions]}
                placeholder="City"
                className="flex-1 min-w-[80px]"
                showSearch={true}
              />
            </div>
          </div>

          <button
            onClick={() => {
              //   getKpiAPIData();
            }}
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <Search size={18} />
            Search
          </button>
        </div>
      </div> */}
      <div>
        <div className="w-full px-8 pt-4 pb-6 inline-flex flex-col justify-start items-start gap-6">
          <div className="self-stretch inline-flex justify-between items-center">
            <div className="flex justify-start items-center gap-3">
              {maintenanceTabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = selectedTab === tab.id;

                return (
                  <button
                    key={tab.id}
                    onClick={() => {setSelectedTab(tab.id); setCityFilter("")}}
                    className={`px-4 py-2.5 rounded-lg flex justify-start items-center gap-2 transition-all duration-200
            ${
              isActive
                ? "bg-blue-800 text-white"
                : "bg-white outline outline-1 outline-slate-200 text-zinc-500 hover:bg-gray-50"
            }`}
                  >
                    <Icon
                      size={20}
                      className={isActive ? "text-white" : "text-zinc-500"}
                    />

                    <span
                      className={`text-sm leading-5 ${
                        isActive
                          ? "font-semibold text-white"
                          : "font-medium text-zinc-500"
                      }`}
                    >
                      {tab.label}
                    </span>
                  </button>
                );
              })}
            </div>
            
            <div className="px-2 py-0.5 bg-amber-600/5 rounded-2xl outline outline-[1.2px] outline-green-800 flex justify-end items-center gap-6">
              <div className="flex justify-start items-center gap-1.5">
                <Wallet size={18} className="text-emerald-700" />

                <div className="text-emerald-900 text-xs font-bold uppercase tracking-tight">
                  Saved Amount
                </div>
              </div>

              <div className="p-2 flex justify-center items-center">
                <div className="text-emerald-900 text-lg font-bold">
                  ₹
                  {savedAmount?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center border-2 border-red-400 rounded-lg gap-3 w-full md:w-auto">
              <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="flex-shrink-0 w-4 h-4"
                >
                  <path
                    d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                    stroke="#b4240a"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                    stroke="#b4240a"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <Citiescommondropdown
                  value={cityFilter}
                  onChange={setCityFilter}
                  options={[
                    { value: null, label: "All Cities" },
                    ...cityOptions,
                  ]}
                  placeholder="City"
                  className="flex-1 min-w-[80px]"
                  showSearch={true}
                />
              </div>
            </div>
          </div>

          <div className="w-full">
            {selectedTab === "pms" ? (
              <PMS
                setSavedAmount={setSavedAmount}
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                cityFilter={cityFilter}
              />
            ) : selectedTab === "runningRepairs" ? (
              <Runningrepair
                setSavedAmount={setSavedAmount}
                cityFilter={cityFilter}
              />
            ) : selectedTab === "accidents" ? (
              <Accidents
                setSavedAmount={setSavedAmount}
                cityFilter={cityFilter}
              />
            ) : (
              <Tinkeringandpainting
                setSavedAmount={setSavedAmount}
                cityFilter={cityFilter}
              />
            )}

            {/* <ComingSoon/> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicestatus;
